import { useAppSelector } from '../../app/hooks';
import type { TaskTrackerMap } from '../../store/investor/taskTrackerResolution';

/**
 * Reads the task-tracker resolution signal that TabSelector publishes to Redux (the sole
 * fetcher — see its own `hasTaskTrackerResolved`/`lastTaskTrackerMapRef`) so any other consumer,
 * e.g. RefreshReport, agrees with the sidebar on whether Management Profile is locked instead of
 * re-deriving its own.
 */
export function useTaskTrackerResolution(): { resolved: boolean; cache: TaskTrackerMap } {
    const resolved = useAppSelector((state) => state.investor.taskTrackerResolved) ?? false;
    const cache = useAppSelector((state) => state.investor.crossModuleTaskTrackerCache) ?? {};
    return { resolved, cache };
}
